import React from 'react';
import './styles.scss';
import { Link } from 'react-router-dom';
import productDataRes from '../../../../components/api/product/findAll.json';
import { Delete as DeleteIcon, Pencil as PencilIcon } from '../../../../components/atoms/icons';
import { IMAGE_URL } from '../../../../config/envConf';
import useRenderCardProduct from './hooks';
import { successUpdateMsg } from '../../../../components/atoms/const';
import Modal from '../../../../components/organisms/modals';

interface Props {
    data: typeof productDataRes.data[0] | undefined;
    category: {value: number, label: string} | null;
    refetchProduct : () => void;
}

function RenderCardProduct(props: Props) {
  const { data, category, refetchProduct } = props;
  const {
    isLoading, result,
  } = useRenderCardProduct(refetchProduct);

  const renderModalBodyDelete = React.useMemo(() => {
    if (!result) return 'Are you sure to remove this user?';
    return successUpdateMsg.SUCCESS_DELETE_PRODUCT_MSG;
  }, [result]);

  return (
    <div className="h-100 w-100">
      <div
        className="h-100"
        style={{ borderRadius: '20px', border: '1px solid #E6E6E6', padding: '10px 4%' }}
      >
        <div className="d-flex justify-content-end align-items-start">
          <Modal.Default
            cancelLabel="No"
            submitLabel="Yes"
            title="Delete Product"
            isLoading={isLoading}
            // onSubmit={() => {
            //   if (data?.id) handleDelete(data.id);
            // }}
            // result={result}
            body={renderModalBodyDelete}
            // onAfterResult={afterDelete}
          >
            <div>
              <DeleteIcon />
            </div>
          </Modal.Default>
          <Link style={{ marginTop: '1px', marginLeft: '5px' }} to={`/products/add/${data?.id}`}>
            <PencilIcon />
          </Link>
        </div>
        <div className="flexible-center mb-3 mt-2" style={{ height: '150px' }}>
          <img src={`${IMAGE_URL}${data?.image}`} alt="productImg" width={100} />
        </div>
        <div className="d-flex mb-1">
          <div className="flex-grow-1 fw-bold fz-14 card-product-title">{data?.name}</div>
          <div className="rounded-pill ms-1" style={{ backgroundColor: '#F3F4F8', minWidth: '100px', height: '20px' }}>
            <div className="fz-12 fw-light text-center" style={{ marginTop: '1px' }}>
              {category?.label ?? '-'}
            </div>
          </div>
        </div>
        <div className="card-product-desc fz-14">{data?.description}</div>
      </div>
    </div>
  );
}

export default React.memo(RenderCardProduct);
